import React from 'react'
import "../../Style/Contact.css"

function Contact() {
    return (
        <div className='contact' data-scroll-section>

            <h1 className='contact-h1'>
                Namaste
            </h1>
            <span className='contact-span'>
                <a href='mailto:dev.piyush.singh@gmail.com'>Say hi</a>
            </span>
        </div>
    )
}

export default Contact